// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/CommentCitationLinks.test.tsx
// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/GraphCitationDialog.test.tsx
import { ArrowSquareOut } from "@phosphor-icons/react";
import { Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import { CITATION_CHIP_CLASS } from "./citationChipStyles";

import {
  type TicketMessageCitation,
  isGraphCitation,
} from "../../utils/commentSourceUtils";
import {
  GraphCitationDialog,
  graphCitationLabel,
} from "../GraphCitationDialog";

/** A relationship the knowledge graph found, on a review comment.
 *
 * The dialog already exists and the chat panel has used it since graph
 * citations shipped; this is the Studio half that was never wired, so a graph
 * citation on a review comment fell to the inert "Source" fallback. */
export function GraphCitationLink({
  citation,
}: {
  citation: TicketMessageCitation;
}) {
  const { t } = useTranslation("ui");
  if (!isGraphCitation(citation)) return null;
  const label = graphCitationLabel(
    citation,
    t("commentCitationLinks.relatedClaim"),
  );

  return (
    <GraphCitationDialog
      citation={citation}
      trigger={
        <button
          type="button"
          data-testid={`comment-panel-citation-graph-${citation.graphNodeId}`}
          aria-label={t("commentCitationLinks.graphChipAriaLabel", { label })}
          className={CITATION_CHIP_CLASS}
        >
          <Text as="span" size="1" weight="medium">
            {label}
          </Text>
          <ArrowSquareOut size={12} aria-hidden="true" />
        </button>
      }
    />
  );
}
